import React from "react";
import BlogsSection from "../components/user/BlogSection/BlogsSection";
import "./Blogs.css";

const Blogs = () => {
  return (
    <div className="blogs-page">
      <BlogsSection />
    </div>
  );
};

export default Blogs;
